import React from 'react';
import PropTypes from 'prop-types';
import {getUrlParam, openPopup} from '../config/windowUtils';

const ActionButtons = ({ onFullResult, onMapView, onPartyWise, showPartyWise = true, showMap = true, showFullResult = true }) => {
  const showControls = !getUrlParam('show');
  if (!showControls) {
    return null;
  }

  return (
    <div className="res-buttons">
      <button
        onClick={() => openPopup('https://results.mathrubhumi.com/result/panchayat-2025/full-result.html',800)}
      >
        FULL RESULT
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
          <g clipPath="url(#clip0_644_1557)">
            <path d="M13.0624 13.6562H8.31244V14.8438H13.0624V13.6562Z" fill="black"/>
            <path d="M7.12494 13.6562H5.93744V14.8438H7.12494V13.6562Z" fill="black"/>
            <path d="M13.0624 10.6875H8.31244V11.875H13.0624V10.6875Z" fill="black"/>
            <path d="M7.12494 10.6875H5.93744V11.875H7.12494V10.6875Z" fill="black"/>
            <path d="M13.0624 7.71875H8.31244V8.90625H13.0624V7.71875Z" fill="black"/>
            <path d="M7.12494 7.71875H5.93744V8.90625H7.12494V7.71875Z" fill="black"/>
            <path d="M14.8438 2.96875H13.0625V2.375C13.0625 2.06006 12.9374 1.75801 12.7147 1.53531C12.492 1.31261 12.1899 1.1875 11.875 1.1875H7.125C6.81006 1.1875 6.50801 1.31261 6.28531 1.53531C6.06261 1.75801 5.9375 2.06006 5.9375 2.375V2.96875H4.15625C3.84131 2.96875 3.53926 3.09386 3.31656 3.31656C3.09386 3.53926 2.96875 3.84131 2.96875 4.15625V16.625C2.96875 16.9399 3.09386 17.242 3.31656 17.4647C3.53926 17.6874 3.84131 17.8125 4.15625 17.8125H14.8438C15.1587 17.8125 15.4607 17.6874 15.6834 17.4647C15.9061 17.242 16.0312 16.9399 16.0312 16.625V4.15625C16.0312 3.84131 15.9061 3.53926 15.6834 3.31656C15.4607 3.09386 15.1587 2.96875 14.8438 2.96875ZM7.125 2.375H11.875V4.75H7.125V2.375ZM14.8438 16.625H4.15625V4.15625H5.9375V5.9375H13.0625V4.15625H14.8438V16.625Z" fill="black"/>
          </g>
          <defs>
            <clipPath id="clip0_644_1557">
              <rect width="19" height="19" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </button>

      <button
        onClick={() => {
          if (onMapView) {
            onMapView();
          } else {
            openPopup(`https://results.mathrubhumi.com/result/localbody-mapview/?page=kerala`, 1000, 1000);
          }
        }}
      >
        MAP VIEW
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"><path d="M16.625 5.67014C16.625 4.84398 16.625 4.43089 16.4009 4.1199C16.1767 3.80891 15.7848 3.67828 15.0011 3.41702L14.0789 3.10966C12.9966 2.74889 12.4555 2.56851 11.9107 2.64147C11.3659 2.71443 10.8913 3.03084 9.94199 3.66366L8.84767 4.39325C8.10659 4.88727 7.7361 5.13428 7.32042 5.23253C7.16776 5.26863 7.0119 5.28949 6.85512 5.29485C6.42825 5.30943 6.00579 5.16861 5.16088 4.88697C4.0542 4.51808 3.50085 4.33363 3.07981 4.52094C2.93033 4.58744 2.7962 4.68411 2.68584 4.8049C2.375 5.14509 2.375 5.72837 2.375 6.89492V10.1124M16.625 8.70833V12.1051C16.625 13.2717 16.625 13.855 16.3142 14.1951C16.2038 14.3159 16.0696 14.4126 15.9202 14.4791C15.4992 14.6664 14.9458 14.482 13.8391 14.113C12.9942 13.8314 12.5717 13.6906 12.1449 13.7052C11.9881 13.7106 11.8322 13.7314 11.6796 13.7675C11.2639 13.8657 10.8934 14.1127 10.1523 14.6068L9.05801 15.3363C8.10873 15.9692 7.63413 16.2856 7.08932 16.3585C6.5445 16.4315 6.00336 16.2511 4.92107 15.8903L3.99896 15.583C3.21519 15.3218 2.8233 15.1911 2.59915 14.8801C2.38693 14.5857 2.37563 14.1997 2.37503 13.4583" stroke="#121212" strokeWidth="1.5" strokeLinecap="round"/><path d="M11.875 2.77087V5.54171M11.875 13.4584V8.70837" stroke="#121212" strokeWidth="1.5" strokeLinecap="round"/><path d="M7.125 16.2291V13.4583M7.125 5.54163V10.2916" stroke="#121212" strokeWidth="1.5" strokeLinecap="round"/></svg>
      </button>

      {showPartyWise && (
        <button onClick={() => {
          if (onPartyWise) {
            onPartyWise();
          } else {
            openPopup(`${window.location.origin}${window.location.pathname}?show=parties`, 700);
          }
        }}>
          PARTY-WISE
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none"><path d="M16.625 9.5C16.625 13.4351 13.4351 16.625 9.5 16.625C5.56497 16.625 2.375 13.4351 2.375 9.5C2.375 5.56497 5.56497 2.375 9.5 2.375M16.625 9.5C16.625 5.56497 13.4351 2.375 9.5 2.375M16.625 9.5H9.5M9.5 2.375V9.5M9.5 9.5L4.4527 14.529" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
      )}
    </div>
  );
};

ActionButtons.propTypes = {
  onFullResult: PropTypes.func,
  onMapView: PropTypes.func,
  onPartyWise: PropTypes.func,
  showPartyWise: PropTypes.bool
};

export default ActionButtons;